import React , { useState, useEffect } from 'react';
// import { API_URL } from './utils/config';
import { Header, Questions } from './component'

function App (props){

  const [infos, setInfos] = useState([]);
  const [haveData, setHaveData] = useState(true)

  const {locale, productKey, context, dataLayer, dataScope, dataCountry } = props;

  // console.log(props)

  var domainName;
  var lang = '&lang=';

  if (context === 'int' || context === 'qual') {
      domainName = 'support-decision-tool.bostik.'+ context +'.eurelis.info/sdt/sdt.json?key=';
  } else if(context === 'prod-test'){
      domainName = 'support-decision-tool.bostik.prod.eurelis.info/sdt/sdt.json?key=';
  } else {
      domainName = 'back.product-selector.bostik/sdt/sdt.json?key=';
  }

  if(!locale){
    lang = '';
  }

  const ApiRequest = 'https://'+ domainName + productKey + lang + locale;

  useEffect(() => {

    function getHostName(url) {
        var match = url.match(/:\/\/(www[0-9]?\.)?(.[^/:]+)/i);
        if (match != null && match.length > 2 && typeof match[2] === 'string' && match[2].length > 0) {
        return match[2];
        }
        else {
            return null;
        }
    }

    fetch(ApiRequest,{
      method: 'GET',
      headers: {
        "Accept-Language": "fr",
      },
    })
    .then((res) => {
      return res.json();
    }).then((data) => {
      if(data.error){
        setHaveData(false)
      }
      setInfos(data)

      const dataLayerContext = getHostName(window.location.href);
      if (dataLayer !== null) {
        dataLayer.push({
            'event' : 'pageInfo',
            'pageType' : 'sdt',
            'bu': 'Construction',
            'context' : dataLayerContext,
            'country' : dataCountry,
            'language': locale,
            'scopeName': data.sdt_main_title,
            'scopeType': dataScope
        });
        // console.log("dataLayer",dataLayer);
      }
    })
    .catch(console.log)

  },[]);

    return (

      <div className="App">
        {haveData &&
        <div>
          <Header Infos={infos}/>
          <Questions Infos={infos} VarProp={props}/>
        </div>
        }
      </div>
    );
}

export default App;
